import { render, staticRenderFns } from "./ExamHistoryDetail.vue?vue&type=template&id=1c6743d9&scoped=true"
import script from "./ExamHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ExamHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamHistoryDetail.vue?vue&type=style&index=0&id=1c6743d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6743d9",
  null
  
)

export default component.exports